/*! digital-design-library - 2.2.0 - Last updated: 2017-08-10. Copyright (c) 2017 AT&T Services, Inc. */ 
/**
 * @ngdoc directive
 * @name Navigation.att:bellybandLinks
 *
 * @description
 *  <file src="src/bellybandLinks/docs/readme.md" />
 *
 * @usage
 *   <div class="bellyband-container autoSize" bellyband-autosize-what=".bellyband-link">
            <div class="bellyband-group span12 span6-sm span12-xsm">
                <div class="span4 span12-sm bellyband-link">
                    <a href="patterns.html">
                        <i class="icon-misc-puzzleL visible-desktop"></i>
                        <i class="icon-misc-puzzle hidden-desktop"></i>
                        <div>
                            <span>Pattern library</span>
                            <p class="hidden-phone">Review our digital design standards and patterns for creating AT&amp;T digital assets. </p>
                        </div>
                    </a>
                </div>
                <div class="span4 span12-sm bellyband-link">
                    <a href="support-development-overview.html">
                        <i class="icon-datanetwork-cloudL visible-desktop"></i>
                        <i class="icon-datanetwork-cloud hidden-desktop"></i>
                        <div>
                            <span>Development overview</span>
                            <p class="hidden-phone">Set up your environment, access the code snippets, and follow our standards for creating a digital code base.</p>
                        </div>
                    </a>
                </div>
                <div class="span4 span12-sm bellyband-link">
                    <a href="getstarted-design-principles.html">
                        <i class="icon-misc-bulbL visible-desktop"></i>
                        <i class="icon-misc-bulb hidden-desktop"></i>
                        <div>
                            <span>Design principles</span>
                            <p class="hidden-phone">Great design is built on an even greater foundation. Learn the ins and outs of our design philosophy.</p>
                        </div>
                    </a>
                </div>
            </div>
        </div>
 
 * @example
 *  <section id="code">   
 <b>HTML + AngularJS</b>
 <example module="ddh.att">
 <file src="src/bellybandLinks/docs/demo.html" />
 <file src="src/bellybandLinks/docs/demo.js" />
 </example>
 </section>
 *
 */
angular.module('ddh.att.bellybandLinks', [])
        .directive('bellybandAutosizeWhat', ['$window', function($window) {
                return {
                    restrict: 'EA',
                    link: function(scope, ele, attr) {
                        var bellyBandGroupElement;
                        var sizeWhat = attr.bellybandAutosizeWhat;
                        var haveBellybandGgroupClass = ele.hasClass('bellyband-group');

                        if (haveBellybandGgroupClass) {
                            bellyBandGroupElement = ele[0];
                        }
                        else {
                            bellyBandGroupElement = ele[0].querySelectorAll('.bellyband-group');
                        }

                        var bellyBandCssCalculation = function() {
                            angular.forEach(ele[0].querySelectorAll('.bellyband-link'), function(value, key) {
                                var newElement = angular.element(value);
                                if ($window.innerWidth <= '479') {
                                    newElement.removeAttr('style');
                                    angular.element(bellyBandGroupElement).removeAttr('style');
                                }
                                if ($window.innerWidth > '479' && $window.innerWidth < '768') {

                                    var lnkHeight = getComputedStyle(value, null).height.split("px");

                                    lnkMar = getComputedStyle(value, null).marginBottom.split("px");

                                    var bblink;

                                    if (ele[0].querySelectorAll('.bellyband-link').length === 2) {
                                        bblink = ((parseInt(lnkHeight[0]) + parseInt(lnkMar[0])) * 1) + 'px';
                                    }

                                    else if ((ele[0].querySelectorAll('.bellyband-link').length === 3) || (ele[0].querySelectorAll('.bellyband-link').length === 4)){
                                        bblink = ((parseInt(lnkHeight[0]) + parseInt(lnkMar[0])) * 2) + 'px';
                                    }

                                    else if (ele[0].querySelectorAll('.bellyband-link').length >= 5) {
                                        bblink = ((parseInt(lnkHeight[0]) + parseInt(lnkMar[0])) * 3) + 'px';
                                    }

                                    angular.element(bellyBandGroupElement).css({
                                        'max-height': bblink
                                    });

                                } else if ($window.innerWidth >= '768') {
                                    
                                   for(var i = 0;i<angular.element(bellyBandGroupElement).length;i++){
                                       
                                        angular.element(bellyBandGroupElement[i]).css({
                                        'max-height': 'inherit'
                                    });
                                       
                                   }
                                    if (angular.element(bellyBandGroupElement).length && angular.element(bellyBandGroupElement)[0].querySelectorAll('.bellyband-link').length === 6) {
                                        newElement.css(
                                                {'flex': '1 1 0'}
                                        );
                                    }
                                }
                            });
                        };

                        function tallestSize() {

                            var maxInnerHeight = -1;
                            angular.forEach(ele[0].querySelectorAll(sizeWhat), function(value, key) {
                                if (maxInnerHeight < value.clientHeight) {
                                    maxInnerHeight = value.clientHeight;
                                }
                            });
                            return maxInnerHeight;
                        }
                        var setautoSize = function() {
                            var autoSize2 = tallestSize() + "px";
                            angular.forEach(ele[0].querySelectorAll('.autoSize .bellyband-link'), function(value, key) {
                                var newElement = angular.element(value);
                                newElement.css({
                                    'height': autoSize2
                                });
                            });
                        };
                        // setautoSize();
                        bellyBandCssCalculation();

                        angular.element($window).bind('resize', function() {
                            angular.element(ele[0].querySelectorAll('.bellyband-link')).removeAttr('style');
                            // setautoSize();
                            bellyBandCssCalculation();
                        });
                    }
                };
            }]);